ion-icon {
  cursor: pointer;
  position: relative;
}
